
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"red"}}),_c('path',{attrs:{"d":"M19.5 7c-5.236 0-9.5 4.144-9.5 9.23 0 2.616 1.34 5.314 3.076 7.838 1.738 2.524 3.91 4.872 5.752 6.662a.97.97 0 001.344 0c1.884-1.83 4.056-4.18 5.783-6.694C27.682 21.52 29 18.84 29 16.23 29 11.144 24.735 7 19.5 7zm0 5.539c2.087 0 3.8 1.664 3.8 3.692 0 2.028-1.713 3.692-3.8 3.692-2.087 0-3.8-1.664-3.8-3.692 0-2.028 1.713-3.693 3.8-3.693z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"19.5","cy":"16.5","r":"6.5","fill":"red"}}),_c('path',{attrs:{"d":"M21.563 14.438l-4.125 4.124M21.563 18.563l-4.125-4.125","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    